// Single source for the customer-support WhatsApp deep-link (the "widget
// system"): the destination number + the wa.me link builder. Reused by
// HelpFAB and the preview page's escape-hatch chips so there's ONE integration.

export const SUPPORT_PHONE_E164 = '212620066907'; // wa.me format strips the '+'

/** Build a WhatsApp deep link to Storiz support with a pre-filled message. */
export function waSupportLink(message: string): string {
  return `https://wa.me/${SUPPORT_PHONE_E164}?text=${encodeURIComponent(message)}`;
}
